import React from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-contrib-quality-levels';
import PlayIcon from '@mui/icons-material/PlayCircle';
import _ from "videojs-contrib-quality-levels";
import qualitySelector from "videojs-hls-quality-selector";

videojs.registerPlugin("qualityLevels", _);
videojs.registerPlugin("hlsQualitySelector", qualitySelector);

export const VideoJS = (props) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const playRef = React.useRef(null);
  const {options, style} = props;
  const [mPlayer, setMPlayer] = React.useState(null)

  React.useEffect(() => {
    if (mPlayer) {
      
      mPlayer.hlsQualitySelector({ displayCurrentQuality: true });
    }
  }, [mPlayer]);
  // function onReady(_player) {
  //   alert(_player.qualityLevels())
  //   // _player.src({p
  //   //   src: liveURL,
  //   //   type: "application/x-mpegURL",
  //   //   withCredentials: false
  //   // });
  //   // this.hlsQualitySelector({ displayCurrentQuality: true });
  // }

  React.useEffect(() => {

    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode. 
      const videoElement = document.createElement("video-js");

    //   videoElement.classList.add('vjs-big-play-centered');
      videoElement.style.height = '200px !important'
      videoElement.style.width = '200px !important'
      videoRef.current.appendChild(videoElement);

      const handlePlayerReady = (player) => {
        playerRef.current = player;

        // You can handle player events here, for example:
        player.on('waiting', () => {
            console.log('player is waiting');
        });

        player.on('dispose', () => {
            console.log('player will dispose');
        });
    };

      const player = playerRef.current = videojs(videoElement, options, function(){
        videojs.log('player is ready');
        var _player = this
        
        // onReady(player);
      });
      setMPlayer(player)

      // const qualityButton = player.controlBar.addChild('button', {
      //   text: 'Quality',
      //   class: 'vjs-quality-button',
      // });

      // qualityButton.on('click', () => {
      //   console.log(player)
      // });

      player.on('play', () => {
        playRef.current.style.display = 'none'
        // Your custom logic when the video starts playing
      });
  
      player.on('pause', () => {
        playRef.current.style.display = 'flex'
        // Your custom logic when the video is paused
      });

    // You could update an existing player in the `else` block here
    // on prop change, for example:
    } else {
      const player = playerRef.current;

      player.autoplay(options.autoplay);
      player.src(options.sources);
    }
  }, [options, videoRef]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
      <div data-vjs-player ref={videoRef} style={{
        width: 800,
        height: 450,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <button onClick={() => playerRef.current.play()} ref={playRef} style={{
            width: 70,
            height: 70,
            borderRadius: '50%',
            backgroundColor: 'white',
            position: "absolute",
            zIndex: 9999,
            border: 'none',
            outline: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <PlayIcon style={{color: '#000000', fontSize: 75}}>Filled</PlayIcon>
        </button>
      </div>
  );
}

export default VideoJS;